import React, { useState, useEffect } from 'react'
import { StockerChart } from 'components/charts'
import CustomizedTable from 'components/CustomizedTable'
import YearRangePicker from 'components/YearRangePicker'
import { useStock } from 'hooks/StockContext'
import useYearRange from 'hooks/useYearRange'
import { Tabs, Tab } from 'react-bootstrap'
import * as StockerAPI from 'utils/StockerAPI'
import * as StockerTool from 'utils/StockerTool'

/*
 * Operating Expenses Data example for google chart
 * operatingExpensesData: [
 *     ["Year/Season", "營業費用率", "推銷費用率", "管理費用率", "研究發展費用率", "營業費用", "推銷費用", "管理費用", "研究發展費用"],
 *     ["2017Q1", 11.18, 0.64, 2.24, 8.3, 26156483, 1496487, 5247603, 19412393]
 * ]
 */
const operatingExpensesKeysOrder = [
  {
    title: 'Year/Season',
    transferToFloat: false
  },
  {
    title: '營業費用率',
    transferToFloat: true
  },
  {
    title: '推銷費用率',
    transferToFloat: true
  },
  {
    title: '管理費用率',
    transferToFloat: true
  },
  {
    title: '研究發展費用率',
    transferToFloat: true
  },
  {
    title: '營業費用',
    transferToFloat: false
  },
  {
    title: '推銷費用',
    transferToFloat: false
  },
  {
    title: '管理費用',
    transferToFloat: false
  },
  {
    title: '研究發展費用',
    transferToFloat: false
  }
]

const OperatingExpensesAnalysis = () => {
  const [operatingExpensesData, setOperatingExpensesData] = useState([
    [
      'Year/Season', '營業費用率', '推銷費用率', '管理費用率',
      '研究發展費用率', '營業費用', '推銷費用', '管理費用', '研究發展費用'
    ],
    ['', 0, 0, 0, 0, 0, 0, 0, 0]
  ])
  const [yearRange, setYearRange] = useYearRange()
  const stock = useStock()

  const handleOperatingExpensesState = operatingExpensesData => {
    setOperatingExpensesData(operatingExpensesData)
  }

  useEffect(() => {
    StockerAPI.getOperatingExpenses(stock.stockNum, yearRange)
      .then(data => StockerTool.formatDataForGoogleChart(
        data, operatingExpensesKeysOrder)
      )
      .then(handleOperatingExpensesState)
  }, [stock.stockNum, yearRange])

  const precentageOperExp = operatingExpensesData.map(d => [].concat(d.slice(0, 5)))
  const rowOperExp = operatingExpensesData.map(d => [].concat(d.slice(0, 1), d.slice(5)))

  return (
    <div className="Operating-Expenses-Analysis">
      <YearRangePicker value={yearRange} onChange={setYearRange} />
      <Tabs defaultActiveKey="precentageOperExp" id="Operating-Expenses-tab">
        <Tab eventKey="precentageOperExp" title="營業費用比例">
          <StockerChart
            type="combo"
            data={precentageOperExp}
            height="400px"
            options={{
              title: '營業費用比例',
              legend: { position: 'top' },
              chartArea: { width: '80%' },
              seriesType: 'line',
              series: {
                0: { visibleInLegend: true },
                1: { visibleInLegend: true },
                2: { visibleInLegend: true },
                3: { visibleInLegend: true }
              },
              pointSize: 7,
              vAxes: {
                0: {}
              },
              hAxis: {}
            }}
          />
        </Tab>
        <Tab eventKey="rowOperExp" title="營業費用資料">
          <StockerChart
            type="combo"
            data={rowOperExp}
            height="500px"
            options={{
              title: '營業費用資料',
              legend: { position: 'top' },
              chartArea: { width: '75%' },
              seriesType: 'line',
              series: {
                0: { visibleInLegend: true },
                1: { visibleInLegend: true },
                2: { visibleInLegend: true },
                3: { visibleInLegend: true }
              },
              pointSize: 7,
              vAxes: {
                0: {}
              },
              hAxis: {
                showTextEvery: 4
              }
            }}
          />
        </Tab>
      </Tabs>
      <CustomizedTable data={operatingExpensesData} />
    </div>
  )
}

export default OperatingExpensesAnalysis
